import { Markdown } from './markdown.js';
import d from './DOM.js';

export default class Terms {
	static init() {
		const markdownScript = d.get<HTMLScriptElement>('terms-markdown');
		const container = d.get<HTMLElement>('terms-content');
		
		if (markdownScript && container) {
			const markdownText = markdownScript.textContent || '';
			const html = Markdown.parse(markdownText);
			container.innerHTML = html;
		}
	}
}
